// extracted by mini-css-extract-plugin
module.exports = {"homecont":"home_homecont__3Iq8s","coldiv":"home_coldiv__3TXFT","pagDiv":"home_pagDiv__3pCrm","col2":"home_col2__2EyWR","messageDiv":"home_messageDiv__3y8ON"};